import React from 'react';
import { Link } from 'react-router-dom';
import PixelCharacter from '../components/PixelCharacter';
import SoloLevelingCharacter from '../components/Sololeveling';
import Venom from '../components/Venom';
import Patrick from '../components/Patrick';
import BowserJr from '../components/BowserJr'
import '../styles/components/_footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-copy">
        <span className="footer-copy-left">
          &copy; {new Date().getFullYear()} <em className="footer-signature-name">Christopher Fabian</em>.
          <Link to="/privacy" style={{ color: 'inherit', opacity: 0.6, marginLeft: '8px', fontSize: '0.85em', textDecoration: 'none' }}>Privacy</Link>
        </span>
        <span className="footer-build-tagline">Built with React + TypeScript · Deployed on AWS Amplify</span>
      </p>
      
      <div className="footer-content">
        <div className="footer-grid-left">
          <div className="grid-area grid-area-1">
            <PixelCharacter />
          </div>
          <div className="grid-area grid-area-2">
             <Venom />
          </div>
          <div className="grid-area grid-area-3">
            <BowserJr />
          </div>
        </div>
        
        <ul className="footer-social-links">
          <li>
            <a href="https://github.com/CNFabian">
              <i className="fab fa-github"></i>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/christopher-fabian7777">
              <i className="fab fa-linkedin"></i>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/chrislucky77/">
              <i className="fab fa-instagram"></i>
            </a>
          </li>
        </ul>
        
        <div className="footer-grid-right">
          <div className="grid-area grid-area-4">
            <Patrick />
          </div>
          <div className="grid-area grid-area-5"></div>
          <div className="grid-area grid-area-6">
             <SoloLevelingCharacter />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;